export default __webpack_public_path__ + "static/media/ottoman.d4417f75.webp";